<template>
  <div>
    <v-card class="main-container">
        <v-card-text>
          <template v-if="is_moderator">
              <v-btn
                  @click="uploadToExcel()"
                  x-small style="margin-left: 15px;">
              <v-badge x-small color="#15336d">
                загрузить в * excel
              </v-badge>
            </v-btn>
          </template>

            <v-data-table
                v-model="selected_users"
                :style="{color: $mainColor}"
                :headers="headers"
                :items="listUsers"
                :loading="preloaderYet"
                loading-text="Загрузка списка заявок ..."
                :items-per-page="50"
                :footer-props="{
                    itemsPerPageOptions: [20, 50, 200],
                    itemsPerPageText: 'кол-во на стр.:',
                }"
            >
            <template v-slot:body="{ items, isSelected, select}">
              <tbody v-if="is_moderator">
                <tr v-for="item in items" :key="item.id" :class="row_classes(item)">
                  <td>
                    <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                    {{ item.user_descr }}
                    </span>
                  </td>
                  <td>
                    <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                      {{ item.organisation }}
                    </span>
                  </td>
                  <td>
                    <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                      {{ item.confirm_type > 0 ? get_type_descr(item.confirm_type) : get_type_descr(item.type) }}
                    </span>
                  </td>
                  <td v-if="is_moderator">
                    <v-tooltip left v-if="item.file_id > 0">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="openFile(item.file)">
                            mdi-file
                            </v-icon>
                        </template>
                        <span>тезисы</span>
                    </v-tooltip>
                  </td>
                  <td v-if="is_moderator">
                    <v-tooltip left v-if="item.file_pdf_id > 0">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="openFile(item.file_pdf)">
                            mdi-file
                            </v-icon>
                        </template>
                        <span>тезисы pdf</span>
                    </v-tooltip>
                  </td>
                  <td v-if="is_moderator">
                    <v-tooltip left v-if="item.exp_file_id > 0">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="openFile(item.exp_file)">
                            mdi-file-key-outline
                            </v-icon>
                        </template>
                        <span>экспертное заключение</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                  <tr v-for="item in items" :key="item.id" :class="row_classes(item)">
                    <td>
                      <span>
                      {{ item.user_descr }}
                      </span>
                    </td>
                    <td>
                      <span>
                        {{ item.organisation }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
        </v-card-text>

    </v-card>

    <v-dialog v-model="dialogUserCard" width="75%">
      <v-card class="main-card">
        <v-card-title text-color="#15336d">
            <v-icon left color="#15336d">mdi-label</v-icon>
            ID:{{ user_meeting_data.id }}
            {{ user_meeting_data.user_descr }}

        </v-card-title>
        <div class="d-flex flex-nowrap justify-space-between">
          
          <div style="width:50%;">
            <v-card-text style="margin-bottom: 15px; margin-left: 15px;">

                <v-card class="pa-2">
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Организация: </b> {{ user_meeting_data.organisation }}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Телефон: </b> {{ user_meeting_data.phone_number }}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>E-mail: </b> {{ user_meeting_data.email }}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Дата рождения: </b> {{ g.toDate(user_meeting_data.birth_date) }}</p>
                  <v-spacer></v-spacer>
                  <div class="pt-3"></div>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Дата регистрации: </b> {{ g.toDate(user_meeting_data.created_at) }}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Формат участия: </b> {{ user_meeting_data.type == 1 ? 'Слушатель' : (user_meeting_data.type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом')}}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(user_meeting_data.section_choice_id) }}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Название доклада: </b> {{ user_meeting_data.comments }}</p>
                  <!-- <p style="margin-bottom: 0px; font-size: 16px;"><b>Пользователь подтвердил участие: </b> {{ user_meeting_data.is_confirm ? 'Да' : 'Нет' }}</p> -->
                  <!-- <p style="margin-bottom: 0px; font-size: 16px;"><b>Дата выступления: </b> {{ user_meeting_data.org_comment }}</p> -->
                    <p style="margin-bottom: 0px; font-size: 16px;"><b>Планирует присутствовать: </b></p>
                    <p  v-for="rec in selected_listen_sections" style="margin-left: 10px; margin-bottom: 0px; font-size: 16px;">{{ '  - ' }} {{ section_descr(rec) }}</p>
                </v-card>

              <v-spacer></v-spacer>
              <div></div>
            </v-card-text>
          </div>

          <div style="width:50%;" class="suggested pr-2">        
            <v-card-text>
                <v-card class="pa-2">
                  <div v-if="edit_mode">
                    <v-card-text>
                      <div class="input-container input-name modal-mul-select">
                        <v-select
                          v-model="new_user_type"
                          :items="user_types"
                          item-text="name"
                          item-value="id"
                          outlined
                          chips
                          required
                        ></v-select>
                      </div>
                    </v-card-text>

                    <v-card-text v-if="new_user_type > 1">
                      <div class="input-container input-name modal-mul-select">
                        <v-select
                          v-model="new_section"
                          :items="all_sections"
                          item-text="name"
                          item-value="id"
                          outlined
                          chips
                          required
                        ></v-select>
                      </div>
                    </v-card-text>
                    <v-card-text v-if="new_user_type > 1">
                      <v-text-field
                        v-model="new_org_comment"
                        outlined
                        required
                        name="input-7-4"
                        label="Дата выступления"
                      ></v-text-field>
                    </v-card-text>

                  </div>
                  <div v-else>
                    <div v-if="user_meeting_data.confirm_type > 1">
                      <p style="margin-bottom: 0px; font-size: 16px;"><b>Подтвержденный формат участия: </b> {{ user_meeting_data.confirm_type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом' }}</p>
                      <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(user_meeting_data.section_confirm_id) }}</p>
                      <p style="font-size: 16px;"><b>Дата выступления: </b> {{ (user_meeting_data.org_comment && user_meeting_data.org_comment.length > 0) ? user_meeting_data.org_comment : 'нет информации'}}</p>
                    </div>
                    <div v-else>
                      <p style="margin-bottom: 0px; font-size: 16px;"><b>Подтвержденный формат участия: </b> {{ user_meeting_data.confirm_type == 1 ? 'Слушатель' : 'нет информации' }}</p>
                    </div>
                    <p style="margin-bottom: 0px; font-size: 16px;"><b>Пользователь подтвердил участие: </b> {{ user_meeting_data.is_confirm ? 'Да' : 'Нет' }}</p>
                  </div>

                  <div class="pt-3"></div>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!edit_mode" color="red darken-1" text @click="edit_mode = true">Изменить</v-btn>
                    <v-btn v-if="edit_mode"  color="red darken-1" text @click="edit_mode = false">Отмена</v-btn>
                    <v-btn v-if="edit_mode"  color="green darken-1" text
                      @click="change_usermeeting()">{{"Сохранить"}}
                    </v-btn>
                  </v-card-actions>

                </v-card>                
            </v-card-text>
                

          </div>

        </div>

      </v-card>

    </v-dialog>

  </div>
</template>


<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'DariaList',
    components: {
    },
    data() {
      return {
        requests: [],
        listUsers: [],
        preloaderYet: false,
        disabledLoadYet: false,
        selected_users: [],

        current_index: 0,
        cur_meeting_id: 2,
        currentProposal: [],
        listRequestFormat: [],
        checkedItemTable: false,
        current_headers: [],
        is_moderator: false,
        headers: [
            { text: 'ФИО', sortable: true, value: 'user_descr'},
            { text: 'Организация', sortable: true, value: 'organisation'},
        ],
        full_headers: [
            { text: 'ФИО', sortable: true, value: 'user_descr'},
            { text: 'Организация', sortable: true, value: 'organisation'},
            { text: 'Формат участия', sortable: true, value: 'confirm_type'},
            { text: '', value: 'actions', sortable: false},
            { text: '', value: 'actions1', sortable: false},
            { text: '', value: 'actions2', sortable: false}
        ],

        user_meeting_data: {},
        dialogUserCard: false,
        user_types: [
            {id: 1, name : 'Слушатель (без доклада)'},
            {id: 2, name : 'Участник с устным докладом'},
            {id: 3, name : 'Участник со стендовым докладом'},
        ],
        edit_mode: false,
        new_user_type: 1,
        new_section: 0,
        new_org_comment: '',
        current_id: null,
        user_meeting_id: 2,
        active_sections_list: {},
        all_sections: [],
        selected_listen_sections: [],

    };
    },
    beforeMount() {
      this.loadNewRequest();
      this.current_headers = this.headers;
    },
 
    mounted() {
      this.update_section_list()
    },

    computed: {
      ...mapGetters([
        'GETTERS_LOGIN',
        'GETTERS_CURRENT_USER',
        'GETTERS_CURRENT_TUB',
        'GETTERS_SECTIONS',
      ]),
    },

    methods: {
      ...mapActions([
        'GET_USER_ALL',
        'GET_LIST_USER_MEETING_NEW',
        'UPLOAD_LIST_TO_EXCEL',
        'UPLOAD_LIST_TO_DOCX',
        'CHANGE_USERMEETING',
      ]),
      ...mapMutations([
        'UPDATE_OVERLAY',
        'UPDATE_BASE_PROPOSAL_ID',
      ]),
      addIdProposals(id) {
        if (this.requests.length !== 0) this.requests = this.requests.filter((item) => item.id !== id);
        else this.requests.push(id);
      },

      get_type_descr(id){
        if(id == 2)
          return 'Устно'
        else if(id == 3)
          return 'Стенд'
        else if(id == 1)
          return 'Слушатель'
        else
          return null
      },

      update_permissions(){
        if (this.GETTERS_CURRENT_USER !== null) {
          try {
            for (var index = 0; index < this.GETTERS_CURRENT_USER.role.length; index++) {
              const element = this.GETTERS_CURRENT_USER.role[index];

              if (element.access_rights == 'moderator' || element.access_rights == 'conf_admin') {
                this.is_moderator = true;
              }
            }
            if(this.is_moderator)
              this.current_headers = this.full_headers

          } catch (ex) {
            console.log('ex ---> ', ex);
          }
        }
      },

      loadNewRequest(index = 0) {
        const stop = false
        this.current_index = index
  
        this.preloaderYet = true;
        this.disabledLoadYet = false;
        this.listUsers = [];

        this.update_permissions()

        var data = {
          meeting_id: this.cur_meeting_id,
          is_moderator: this.is_moderator,
          daria_only: true
        }

        this.GET_LIST_USER_MEETING_NEW(data)
          .then((res) => {
            this.preloaderYet = false;
            this.disabledLoadYet = true;
            this.listUsers = res;
          })
          .catch(() => this.preloaderYet = false);
      },

      section_descr(id){
        if(id > 0)
          return this.active_sections_list[id].name
        else
          return 'Не указано при регистрации!'
      },

      update_section_list(){
        this.all_sections = []
        this.GETTERS_SECTIONS.forEach((item) => {
          // if(item.is_active && item.is_public){
            this.all_sections.push(item)
          // }
          this.active_sections_list[item.id] = item
        })

      },

      uploadToExcel() {
        this.UPDATE_OVERLAY(true)
        this.UPLOAD_LIST_TO_EXCEL({type: 'daria'})
          .then((res) => {
            this.UPDATE_OVERLAY(false)
            window.open(res.url, '_blank');
          })
          .catch((e) => {
            this.UPDATE_OVERLAY(false)
          });
      },

      change_usermeeting(){
        var data = {
          type: 'admin_change',
          id: this.current_id,
          new_user_type: this.new_user_type,
          new_section: this.new_section,
          new_org_comment: this.new_org_comment,
        }
        this.UPDATE_OVERLAY(true)
        this.CHANGE_USERMEETING(data)
          .then((res) => {
            this.UPDATE_OVERLAY(false)
            this.edit_mode = false
            this.loadNewRequest();
            this.openDetailInfo(this.current_id)
          })
          .catch(() =>{
            this.edit_mode = false
            this.UPDATE_OVERLAY(false)
          });
      },

      openFile(fileName) {
        window.open(`https://api.kcsni-service.ru/media/${fileName}`, '_blank')
      },

      async openDetailInfo(id) {
        this.UPDATE_OVERLAY(true)
        this.GET_USER_ALL(id)
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          this.current_id = id
          this.user_meeting_data = res
          this.new_section = this.user_meeting_data.confirm_type > 0 ? this.user_meeting_data.section_confirm_id : this.user_meeting_data.section_choice_id 
          this.new_org_comment = this.user_meeting_data.org_comment ? this.user_meeting_data.org_comment : '' 
          if(this.user_meeting_data.confirm_type > 0){
            this.new_user_type = this.user_meeting_data.confirm_type
          }
          else{
            this.new_user_type = this.user_meeting_data.type
          }
          

          this.selected_listen_sections = []
          var ls = []
          if(this.user_meeting_data.listen_sections !== null)
            ls = this.user_meeting_data.listen_sections.split(', ')
          ls.forEach((item) => {
            this.selected_listen_sections.push(parseInt(item))
          })




          this.dialogUserCard = true
        })
        .catch(() =>{
          this.UPDATE_OVERLAY(false)
        });
      },

      addIdSwitchRequest(id) {
        this.requests = [];
        if (this.requests.length !== 0) {
          this.requests.forEach((item) => {
            Number(item) !== Number(id) ? this.requests.push(id) : null;
          });
        } else this.requests.push(id);
      },
      
      row_classes(item) {
        if(this.is_moderator){
          if(item.is_confirm)
            return "green_bg";
          else if(item.confirm_type == 0)
            return "yellow_bg";
          else
            return "white_bg";
        }
        else
          return "white_bg";

      },  
    },

    watch: {
      GETTERS_SECTIONS(val) {
        this.update_section_list()
      },

      GETTERS_CURRENT_USER(val){
        this.update_permissions()
      },

    },
  };

</script>
<style scoped>

.green_bg {
  background-color: #93e093;
}
.yellow_bg {
  background-color: #ede84d;
}
.white_bg {
  background-color: rgb(255, 255, 255);
}
.green-bg {
  /* `!important` is necessary here because Vuetify overrides this */
  display: table-row;
  background: rgb(106, 246, 106) !important; 
}

.main-container{
    border-radius: 13px!important;
}
.headline{
    font-size: 12px;
  }
.btn-load-more{
    color: rgb(22, 51, 110);
    border-radius: 0px;
    box-shadow: none;
    margin-bottom: -26px;
    width: 100%;
    z-index: 1;
}
.v-card{
  margin-bottom: 30px;
    border: 0px;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
    border-radius: 13px;
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,0.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,0.05);
}

</style>
<style>
.v-application .v-tabs-slider-wrapper {
    color: #15336d !important;
}
</style>